import { Flex, SkeletonBox, Spacing, Text } from '@billy/design-system'
import type { ReactElement, ReactNode } from 'react'

interface InvoicingSettingsFormPlaceholderProps {
  children?: ReactNode
  title: string
}

// This is a temporary solution to display the form skeletons while the form is being developed.
export const invoicingSettingsFormSkeletons = [
  { height: 48, id: 'field-1' },
  { height: 72, id: 'field-2' },
  { height: 48, id: 'field-3' },
  { height: 96, id: 'field-4' },
  { height: 48, id: 'field-5' },
  { height: 72, id: 'field-6' },
  { height: 48, id: 'field-7' },
  { height: 96, id: 'field-8' },
  { height: 48, id: 'field-9' },
  { height: 72, id: 'field-10' },
  { height: 96, id: 'field-11' },
  { height: 48, id: 'field-12' },
  { height: 72, id: 'field-13' },
]

export const InvoicingSettingsFormPlaceholder = ({
  children,
  title,
}: InvoicingSettingsFormPlaceholderProps): ReactElement => (
  <Flex flexDirection="column" gap={Spacing.S24}>
    <Text variant="h2">{title}</Text>
    {children}
    <Flex flexDirection="column" gap={Spacing.S16}>
      {invoicingSettingsFormSkeletons.map(({ height, id }) => (
        <SkeletonBox key={id} fullWidth height={height} />
      ))}
    </Flex>
  </Flex>
)
